var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicalDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Party-Music-Dance--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Party Music Dance Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.53 8.7a2.41 2.41 0 0 0 1.79 -0.52 2.48 2.48 0 0 0 0.89 -1.57l0.38 -3.42A0.24 0.24 0 0 1 5.75 3 0.23 0.23 0 0 1 6 3l0.87 0.73a1 1 0 1 0 1.29 -1.5L6.22 0.59A1.52 1.52 0 0 0 4.69 0.35a1.48 1.48 0 0 0 -0.93 1.23l-0.24 2.1a0.24 0.24 0 0 1 -0.1 0.18 0.25 0.25 0 0 1 -0.19 0l-0.16 0A2.42 2.42 0 0 0 0.39 6a2.44 2.44 0 0 0 2.14 2.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84 13.8a1 1 0 0 0 -0.59 -1.28l-1.13 -0.42a1.53 1.53 0 0 0 -1.52 0.28 1.5 1.5 0 0 0 -0.46 1.47l0.2 0.87a0.24 0.24 0 0 1 -0.11 0.27 1.69 1.69 0 1 0 2.48 1.07c0 -0.09 -0.26 -1.12 -0.35 -1.49a0.17 0.17 0 0 1 0 -0.15 0.2 0.2 0 0 1 0.15 0 1 1 0 0 0 1.33 -0.62Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.13 4.26a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12 7.48a1.45 1.45 0 0 0 -0.93 0.33l-0.73 0.58a2.52 2.52 0 0 1 -1.56 0.54 2.44 2.44 0 0 1 -0.9 -0.16 6.88 6.88 0 0 0 -4.79 0 2.7 2.7 0 0 1 -1.2 0.29 2.59 2.59 0 0 1 -1.29 -0.36l-0.82 -0.51A1.54 1.54 0 0 0 9.13 8a1.51 1.51 0 0 0 -1.29 0.72 1.49 1.49 0 0 0 0.51 2.06l0.85 0.51a5.49 5.49 0 0 0 2.82 0.79 6.57 6.57 0 0 0 2.05 -0.38 0.27 0.27 0 0 1 0.15 0.05 0.31 0.31 0 0 1 0.15 0.23l0.13 1.29a0.5 0.5 0 0 1 -0.28 0.5l-1.55 0.78a5.46 5.46 0 0 0 -3 4.92v2a1.5 1.5 0 0 0 3 0v-2A2.48 2.48 0 0 1 14 17.21l0.4 -0.2a0.16 0.16 0 0 1 0.15 0 0.14 0.14 0 0 1 0.07 0.12 5.55 5.55 0 0 0 1.1 3.31l2 2.71a1.5 1.5 0 0 0 2.4 -1.8l-2 -2.72a2.46 2.46 0 0 1 -0.5 -1.5c0 -0.08 -0.21 -4.75 -0.21 -4.75a0.51 0.51 0 0 1 0.16 -0.41 0.47 0.47 0 0 1 0.42 -0.13 5.61 5.61 0 0 0 4.34 -1.12l0.72 -0.58a1.5 1.5 0 0 0 -0.94 -2.67Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicalDrama);
export default ForwardRef;